import { Typography, Spacer, Button, Flex, Badge } from '@jisr-hr/ds'
import stoc from 'string-to-color'
import i18n from 'translations/i18n'
import { LazyAvatar } from 'components/global/atoms'
import { OnboardingAdminType } from 'redux/organizationOnborading/inviteAdmins/type'

type TProps = {
  fetching: boolean
  list: OnboardingAdminType[]
  onClick: (values: OnboardingAdminType) => void
}

const status = {
  accepted: 'success',
  expired: 'warning',
  pending: 'gray',
  initiated: 'gray',
}

const InvitedAdmins = (props: TProps): JSX.Element => {
  const { list, fetching } = props

  return (
    <Flex
      flexCol
      style={{ gap: 12, maxHeight: 140, overflowY: 'auto' }}
    >
      {list.map((admin, key) => (
        <Flex
          key={key}
          style={{ height: 32 }}
        >
          <Flex
            itemsCenter
            style={{ width: 240 }}
          >
            <LazyAvatar
              style={{
                width: 24,
                height: 24,
                color: '#fff',
                backgroundColor: stoc(admin.full_name_i18n || admin.email),
              }}
              alt={admin.full_name_i18n || admin.email}
            />
            <Typography
              text={admin.full_name_i18n || admin.email}
              variant="body-new/semibold"
              style={{ color: 'var(--ds-base-color-content-on-neutral-fg)' }}
            />
          </Flex>
          {admin.invitation_status && admin.invitation_status_i18n && (
            <Flex itemsCenter>
              <div style={{ width: 92 }}>
                <Badge
                  size="sm"
                  label={admin.invitation_status_i18n}
                  variant={status[admin.invitation_status]}
                />
              </div>
              <Spacer width={4} />
              {['pending', 'initiated'].includes(admin.invitation_status) && (
                <Button
                  size="sm"
                  type="button"
                  disabled={fetching}
                  variant="tertiaryGray"
                  label={i18n.t('label.undo')}
                  onClick={(): void => props.onClick(admin)}
                />
              )}
              {admin.invitation_status === 'accepted' && (
                <Button
                  size="sm"
                  type="button"
                  disabled={fetching}
                  variant="tertiaryGray"
                  label={i18n.t('label.delete_admin')}
                  onClick={(): void => props.onClick(admin)}
                />
              )}
              {admin.invitation_status === 'expired' && (
                <Button
                  size="sm"
                  type="button"
                  variant="tertiary"
                  disabled={fetching}
                  label={i18n.t('label.re-invite')}
                  onClick={(): void => props.onClick(admin)}
                />
              )}
            </Flex>
          )}
        </Flex>
      ))}
    </Flex>
  )
}

export default InvitedAdmins
